import { minutesToMilliseconds } from 'date-fns';

export const MAX_MINUTES_ORDER_CHECK = 180; // 3 hours
export const QUEUE_BANNER_POLLING_FREQUENCY = minutesToMilliseconds(1);
export const OPEN_TRACKING_MODAL_PARAM = 'openTrackingModal';
